import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getToken } from "./../../utils/utils";

export const fetchProperty = createAsyncThunk(
  "fetchProperty",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/property/list.php?page=" +
      data.page +
      "&limit=" +
      data.limit;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchPropertySearch = createAsyncThunk(
  "fetchPropertySearch",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/property/search.php?search=" +
      data;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.property;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const fetchPropertyEdit = createAsyncThunk(
  "fetchPropertyEdit",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/property/details.php?id=" +
      data.id;
    const authorization = getToken();
    const options = {
      method: "get",
      headers: {
        Authorization: "Bearer " + authorization,
      },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data.property[0];
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const saveProperty = createAsyncThunk(
  "saveProperty",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/property/create.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.property) return result.data.property;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const editProperty = createAsyncThunk(
  "editProperty",
  async (data, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL + "/controller/property/update.php";
    const authorization = getToken();
    const options = {
      method: "post",
      headers: {
        Authorization: "Bearer " + authorization,
        "Content-Type": "multipart/form-data",
      },
      url,
      data: data,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          if (result.data.property) return result.data.property;
          else return result.data.message;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);

export const deleteProperty = createAsyncThunk(
  "deleteProperty",
  async (id, thunkAPI) => {
    const url =
      process.env.REACT_APP_API_URL +
      "/controller/property/delete.php?id=" +
      id;
    const authorization = getToken();
    const options = {
      method: "delete",
      headers: { Authorization: "Bearer " + authorization },
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.status) {
          return result.status;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
